<template>
  <section class="section_dethi ebook-list css-trans">
    <div class="ss-data">
      <div class="container-hts">
        <b-tabs class="book-detail__tabs tabs-tooltip" v-if="ebooks && ebooks.length > 0 && ebooks[0].bookTypeId !== 0">
            <b-tab class="book-detail__tab" v-for="(item, index) in ebooks" :active="tabActive == index ? true : false" :key="index" @click="checkChangeTab($event, index)">
              <template v-slot:title>
                <span :title="item.name">{{ item.name }}</span>
                <!-- v-b-tooltip.hover -->
              </template>
              <div class="ss-data list__box__body list__box__body--grid">
                 <!-- <div class="row">
                  <div class="col-12 m-3 container-hts">
                    <img v-if="item && item.imageUrl" v-lazy="thumbUrl(item.imageUrl)" class="float-left img-150 mr-3"/>
                    <div class="primary-color-txt mt-4">{{item.description}}</div>
                  </div>
                </div> -->
                <div class="box_content" v-for="(groupItem, index3) in item.bookGroups" :key="index3">
                  <!-- <div class="row">
                    <div class="col-12 m-3"> -->
                      <h4 class="font-size-22 font-sanpro-semibold primary-color-txt group-book">{{groupItem.name}}</h4>
                    <!-- </div>
                  </div> -->
                  <div class="row" v-if="groupItem&&groupItem.books&&groupItem.books.length>0">
                    <div class="item col-xl-3 col-lg-4 col-md-4 col-sm-6" v-for="(itemBook, index4) in groupItem.books" :key="index4">
                      <ItemBook :itemBook="{...itemBook, tabActive: item.bookTypeId}"  />
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-12 m-3 secondary-color-txt text-center">
                      Đang cập nhật sách lên hệ thống
                    </div>
                  </div>
                </div>
              </div>
          </b-tab>
        </b-tabs>
        <b-tabs class="book-detail__tabs" v-else-if="ebooks && ebooks.length > 0  && ebooks[0].bookTypeId === 0">
          <b-tab class="book-detail__tab" v-for="(item, index) in ebooks[0].bookGroups" :active="tabActive === index" :key="index" @click="checkChangeTab($event, index)">
            <template v-slot:title>{{ item.name }}</template>
            <div class="row list__box__body list__box__body--grid" v-if="item.books && item.books.length>0">
              <div class="item col-xl-3 col-lg-4 col-md-4 col-sm-6" v-for="(itemBook, index2) in item.books" :key="index2">
                <ItemBook :itemBook="{...itemBook, tabActive: index}" />
              </div>
            </div>
            <div class="col-12 m-3 secondary-color-txt text-center" v-else>
              Đang cập nhật sách lên hệ thống
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { STORE_KEY, LOCAL_SAVE_TAB_LISTPAGE } from '../_store/constants'
  import store from '../_store'
  import { APP_CONFIG } from '@/utils/constants'
  import ItemBook from './ebooklist/ItemBook.vue'
  // const imgNext = require('@/assets/images/next.png')
  // const imgPrev = require('@/assets/images/prev.png')
  const imgBookType1 = require('@/assets/images/book/book_type_1.png')
  const imgBookType2 = require('@/assets/images/book/book_type_2.png')
  //const imgBanner = require('@/assets/images/book/banner_sdt.jpg')
  // const imgBanner = require('@/assets/images/banner.png')

export default {
  name: 'EBookList_PC',
  components: {
   ItemBook
  },
  data() {
    return {
      filterType: 0,
      // imgNext,
      // imgPrev,
      imgBookType1,
      imgBookType2,
      // imgBanner,
      cdnUrl: APP_CONFIG.cdnUrl,
      selectType: 0,
      selectClass: 1,
      tabActive: null
    }
  },
  computed: {
    ...mapGetters({
      ebooks: STORE_KEY + '/ebooks',
      filterObj: STORE_KEY + '/ebooksFilter',
      filters: STORE_KEY + '/filters'
    })
  },
  watch: {
    ebooks(newVal) {
      this.checkRouterActiveTab();
    }
  },
  methods:{
    thumbUrl(filename) {
      return require(`@/assets${filename}`);
    },
    viewAll(type){
      this.filterType= type;
    },
    isFilter(){
      return (this.filterObj.book_type!=null &&this.filterObj.book_type.length>0)
      || (this.filterObj.classes!=null && this.filterObj.classes.length>0)
      || (this.filterObj.levels!=null && this.filterObj.levels.length>0)
      || (this.filterObj.subjects!=null && this.filterObj.subjects.length>0);
    },
    filterBooks(filterData){
      this.$store.dispatch(STORE_KEY + '/getEBooks',filterData);
    },

    checkChangeTab(evt, index) {
      localStorage.setItem(LOCAL_SAVE_TAB_LISTPAGE, index);
      this.$router.replace({ name: 'ebook', query: {book_active: index, classes: this.$router.history.current.query.classes} })
    },

    checkRouterActiveTab() {
      let countTabEbook = this.ebooks ? this.ebooks.length : 0;
      let paramBookQueryCurr = this.$router.history.current.query.book_active;
      // this.tabActive = parseInt(paramBookQueryCurr) > parseInt(countTabEbook) ? 0 : parseInt(paramBookQueryCurr);
      this.tabActive = paramBookQueryCurr;
      // this.$router.replace({ name: 'ebook', query: {book_active: this.tabActive} })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>